import React, { createContext, useContext } from 'react';
import { useGameAudio } from './hooks/useGameAudio';

const AudioContext = createContext(null);

export function AudioProvider({ children }) {
  const audio = useGameAudio({ enabled: true, masterVolume: 0.8 });

  return <AudioContext.Provider value={audio}>{children}</AudioContext.Provider>;
}

export function useAudio() {
  const context = useContext(AudioContext);
  if (!context) {
    throw new Error('useAudio must be used within AudioProvider');
  }
  return context;
}
